module.exports = __webpack_public_path__ + "img/leftArrow.4a99aafe.svg";